export enum UrgencyRating {
  Routine = 'routine',
  SubAcute = 'sub_acute',
  Acute = 'acute',
}
